import React from 'react';
import '../styles/AboutSection.css';

function Navigation() {
    return (
        <nav>
            <div className="nav-container">
                <div className="logo">
                    <svg width="40" height="40" viewBox="0 0 181 185" fill="none" style={{ display: 'inline-block' }}>
                        <defs>
                            <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" style={{ stopColor: '#FF6B35', stopOpacity: 1 }}/>
                                <stop offset="100%" style={{ stopColor: '#FF8E53', stopOpacity: 1 }}/>
                            </linearGradient>
                            <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
                                <feGaussianBlur stdDeviation="4" result="coloredBlur"/>
                                <feMerge>
                                    <feMergeNode in="coloredBlur"/>
                                    <feMergeNode in="SourceGraphic"/>
                                </feMerge>
                            </filter>
                        </defs>
                        <path
                            d="M180.007 75.9292C177.037 74.6192 165.067 67.2892 148.087 63.1092C142.204 61.661 134.167 61.6092 122.167 66.0542C110.167 70.4992 94.3266 80.0692 82.5366 86.4842C63.8828 96.6339 53.6966 99.5892 48.3816 100.259C41.7466 99.6092 35.3666 97.9392 29.5516 94.2942C26.3766 91.6392 22.7466 87.3492 19.0066 83.9292"
                            stroke="url(#logoGradient)"
                            strokeWidth="3.5"
                            strokeLinecap="round"
                            className="logo-path"/>
                        <path
                            d="M84.0066 129.232C88.6566 126.582 95.3066 117.952 99.4966 98.1372C100.309 94.294 100.007 93.2522 99.5116 93.2372C97.736 93.1834 96.0166 101.502 94.5166 122.387C93.469 136.974 94.0066 159.772 94.6666 171.667C95.3266 183.562 96.6466 183.892 98.6466 183.402C103.287 181.592 110.627 177.262 121.257 169.627C127.267 164.962 134.527 158.692 142.007 152.232"
                            stroke="url(#logoGradient)"
                            strokeWidth="3.5"
                            strokeLinecap="round"
                            className="logo-path"/>
                        <path
                            d="M65.0066 28.2322C69.9866 27.5722 77.9666 25.5722 83.4866 25.0672C90.0227 24.4693 98.6066 22.9122 106.147 21.7372C111.607 20.2522 115.997 18.9022 118.652 18.0722C120.317 17.5722 122.627 16.9122 127.007 17.2322"
                            stroke="url(#logoGradient)"
                            strokeWidth="3.5"
                            strokeLinecap="round"
                            className="logo-path"/>
                        <path
                            d="M65.6421 27.2878C65.4472 27.8755 64.2716 30.2237 62.204 34.0665C59.8134 38.5097 59.3419 43.9111 59.4866 46.5177C59.7066 50.4789 66.8059 51.1121 70.3547 51.2613C73.8118 51.4066 78.8982 50.1433 82.7129 47.8749C86.9447 45.3585 88.5627 41.2882 90.4486 39.6474C90.7397 39.3941 91.0378 39.1084 91.091 39.2014C91.9934 40.7806 90.453 43.3262 91.4809 45.543C92.0937 46.8646 94.7683 47.2724 97.8638 47.5677C100.462 47.8156 102.749 47.4732 106.031 46.6417C111.635 45.2217 116.041 43.341 118.104 42.3102C121.824 40.4514 125.478 35.688 128.058 31.7301C129.885 28.9265 130.221 22.2133 131.113 18.9244C131.214 18.5301 131.214 18.0427 131.311 17.5967C131.409 17.1507 131.604 16.7608 131.214 16.6545"
                            stroke="url(#logoGradient)"
                            strokeWidth="3.5"
                            strokeLinecap="round"
                            className="logo-path"/>
                        <path
                            d="M129.146 16.9499C129.341 16.9499 129.536 16.9499 129.978 16.8524C130.419 16.7549 131.102 16.56 130.478 16.4596C129.855 16.3591 127.906 16.3591 126.488 16.6545"
                            stroke="url(#logoGradient)"
                            strokeWidth="3.5"
                            strokeLinecap="round"
                            className="logo-path"/>
                        <path
                            d="M72.7309 26.9924C72.7309 27.7722 70.9764 31.3904 68.5618 36.264C67.7699 37.8623 68.389 37.921 68.8838 37.8723C70.7056 37.6928 72.4238 36.645 76.0154 34.1905C76.9181 33.5736 77.445 32.9116 77.6975 32.8052C78.9342 32.2846 73.1563 40.3312 70.9617 44.3143C70.2705 45.5976 69.6827 46.7761 68.8941 47.9591C68.6962 48.2559 68.5013 48.5484 68.3004 49.145"
                            stroke="url(#logoGradient)"
                            strokeWidth="3.5"
                            strokeLinecap="round"
                            className="logo-path"/>
                        <path
                            d="M68.5958 4.24906C67.7097 8.27788 68.0996 10.4459 68.9842 12.0689C70.5839 15.004 73.2153 14.6815 75.28 15.2249C79.2392 16.2671 83.6241 16.0638 88.127 15.3283C88.8779 15.2057 89.3602 15.1777 91.9018 14.4954C94.4434 13.8131 99.0246 12.4485 103.042 10.7708C107.059 9.0931 110.373 7.14367 112.86 5.55459C115.347 3.96551 116.906 2.79585 118.513 1.00002"
                            stroke="url(#logoGradient)"
                            strokeWidth="3.5"
                            strokeLinecap="round"
                            className="logo-path"/>
                        <path
                            d="M4.50092 67.1624C5.0887 67.2599 11.7256 70.5769 16.7498 73.7521C17.3217 74.1135 17.6862 74.3458 18.2282 74.2513C22.6897 71.1233 28.4198 66.3768 29.6515 65.6886C29.9971 65.4907 30.387 65.2957 31.084 64.7995"
                            stroke="url(#logoGradient)"
                            strokeWidth="3.5"
                            strokeLinecap="round"
                            className="logo-path"/>
                        <path
                            d="M2.13798 58.3014C2.13798 57.817 1.74809 55.4541 1.05693 52.6023C0.517943 50.3784 3.89246 47.3905 8.07931 44.3792C9.56521 43.3105 11.0906 43.0427 12.3193 42.7473C13.9072 42.3656 15.7131 43.6275 17.4912 44.7588C19.2873 45.9014 20.4449 47.3669 20.7964 48.3549C20.8557 48.5217 20.2618 48.3593 20.1584 48.0167C19.3853 45.4544 25.6434 42.4638 29.3502 41.2705C31.5717 40.5554 34.2268 42.9364 36.1969 45.4913C37.9108 47.714 37.2868 50.7104 36.3564 52.9272C35.6209 53.9595 34.7318 54.949 33.9447 55.8823C33.6449 56.3283 33.5474 56.7182 33.447 57.1199"
                            stroke="url(#logoGradient)"
                            strokeWidth="3.5"
                            strokeLinecap="round"
                            className="logo-path"/>
                    </svg>
                </div>
                <div className="nav-links">
                    <a href="#hero">Главная</a>
                    <a href="#about">Обо мне</a>
                    <a href="#projects">Проекты</a>
                    <a href="#resume">Резюме</a>
                    <a href="#contacts">Контакты</a>
                </div>
                <div className="mobile-menu-btn">
                    <i className="fas fa-bars"></i>
                </div>
            </div>
        </nav>
    );
}

export default Navigation;
